"use client";
import { LottieFileTypes } from "@/api/AppApi/services/company/interfaces/ICompany";
import PaymentSuccessLottie from "./Lottie-svgs/SvgPaymentSuccessLottie";
import SvgPaymentFailLottie from "./Lottie-svgs/SvgPaymentFailLottie";
interface Props {
  lottieFileType: LottieFileTypes;
  size?: number;
  inline?: boolean;
}
const LottieFile: React.FC<Props> = ({ lottieFileType }) => {
  return (
    <div
      style={{
        margin: "0 auto",
      }}
    >
      {GetLottieFileImage(lottieFileType)}
      {/* @ts-ignore */}
      {/* <Lottie
        animationData={data}
        style={{ width: size ?? defaultSize, height: size ?? defaultSize }}
      /> */}
      {/* <LottiePlayerLight
        animationData={data}
        play
        loop
        rendererSettings={{ preserveAspectRatio: "xMidYMid slice" }}
        style={{ width: size ?? defaultSize, height: size ?? defaultSize }}
      /> */}
    </div>
  );
};
export default LottieFile;

const GetLottieFileImage = (lottieFileType: LottieFileTypes) => {
  switch (lottieFileType) {
    case LottieFileTypes.payment_success:
      return (
        <div className="mb-4">
          <PaymentSuccessLottie />
        </div>
      );
    case LottieFileTypes.payment_fail:
      return (
        <div className="mb-4">
          <SvgPaymentFailLottie />
        </div>
      );
    default:
      break;
  }
};
